import { convertDigitToProperFormat } from 'utils/number';
import { getLanguageBaseOnTZ } from '../../../utils/LanguageLocalStorage';
import i18n from '../../../i18n';

const messages = {
  matchRoleAndMoveToImplicit:
    'به روز رسانی عضویت نقش و انتقال کاربر به کاربران ضمنی',
  createAndMoveToImplicit: 'ساخت عضویت نقش و انتقال کاربر به کاربران ضمنی',
  moveToImplicit: 'انتقال به کاربران ضمنی',
  addMemberToProject: 'افزودن کاربر به پروژه',
  selectMember: 'انتخاب فرد',
  addTag: 'افزودن برچسب',
  admin: 'مدیر پروژه',
  archived: 'بایگانی شده',
  areYouSure: 'آیا از انجام این کار مطمئن هستید؟',
  cancel: 'لغو',
  canCreate: 'امکان ساختن وظیفه',
  canCreateAsRoot: 'امکان ساختن به عنوان ریشه',
  customConfig: 'تنظیمات سفارشی',
  defaultValue: 'مقدار پیشفرض',
  inactive: 'غیر فعال',
  projectNamesPlaceHolder: 'عنوان پروژه را وارد کنید',
  projectNames: 'عناوین پروژه‌ها',
  batchAdd: 'افزودن گروهی',
  pleaseEnterProjectName: 'لطفا عنوان پروژه را وارد کنید',
  headerLastNameColumn: 'نام و نام خانوادگی اعضای کمیته',
  pleaseSpecifyUser: 'لطفا فرد یا سمت مرتبط را مشخص کنید',
  alreadyExists: 'این فرد در پروژه عضو است',
  roleAlreadyExists: 'این سمت در پروژه عضو است',
  willBeAdded: 'این فرد به پروژه اضافه خواهد شد',
  companyMember: 'کاربر عضو',
  relatedRole: 'سمت مرتبط',
  submit: 'ثبت',
  pleaseCheckTheseUsers: 'لطفا اطالاعات این افراد را بازبینی کنید',
  addAsRole: 'افزودن با استفاده از سمت',
  roleWillBeAdded: 'این سمت به پروژه اضافه خواهد شد',
  applyToAll: 'اعمال به همه:',
  show: 'نمایش',
  addBatchMembers: 'افزودن گروهی اعضا',
  role: 'سمت',
  projectGroups: 'گروه پروژه',
  batchAddMembersToProjects: 'افزودن گروهی اعضا به پروژه ها',
  addOrUpdateRole: 'افزودن یا به روزرسانی سمت در پروژه‌ها',
  oprationDone: 'عملیات انجام شده',
  saved: 'ذخیره شد',
  options: 'گزینه‌ها',
  roleInProject: 'سمت',
  roleInProjectEx: 'سمت در پروژه',
  memberAddRemoveTutorial: 'دستورالعمل تغییر در کاربران',
  memberAddRemoveTutorialText:
    'در ثبت یا تغییر اعضای کمیته تا حد امکان از سمت ها استفاده کنید تا با تغییر سمت افراد نیاز به تغییر دوباره وجود نباشد.\n' +
    'حذف عضو اصلی کمیته:\n' +
    '- در صورتی که یک عضو اصلی بخواهد تغییر کند، چنانچه به صورت کامل از پروژه(کمیته/برنامه عملیاتی) حذف گردد، دسترسی ایشان به وظایف (کمیته و برنامه‌ها) قبلی که در آن عضو بوده نیز از بین میرود لذا برای جلوگیری از این موضوع بایستی به اعضای ضمنی پروژ منتقل گردد.\n' +
    '- نقش فرد در پروژه نیز بایستی حذف گردیده و دقیقا با همان عنوان به فرد جدیدی داده شود.\n' +
    ' - همچنین باید دسترسی ها نیز متناسب با نیاز تغییر کند و اعضای پروژه با توجه به دسترسی تعیین شده می‌توانند وظایف ایجاد شده در پروژه را  ببینند و بین اعضای ضمنی و اصلی تفاوتی وجود ندارد.\n' +
    '\tدسترسی‌ها به شرح زیر می‌باشد:\n' +
    '\tنمایش وظایف\n' +
    '- به تفکیک هر کاربر عضو پروژه می‌توان با فعال کردن تیک نمایش تمام وظایف اجازه مشاهده تمام وظایف موجود در پروژه (حتی اگر به عنوان یک فرد مرتبط هم نیست) را به او داد.  \n' +
    '- در صورتی که یک فرد اجازه نمایش تمام وظایف در پروژه را نداشته باشد تنها وظایفی که به فرد محول شده یا مطلع یا تایید کننده و یا منتشر کننده است را می‌بیند و همچنین در این وظایف در صورتی که فقط مجری باشد حتی سایر مجری‌ ها را نمی بیند. \n' +
    '\tساخت وظایف\n' +
    '- یک فرد تنها در صورتی می‌تواند در یک پروژه(کمیته/برنامه) یا به عنوان زیروظیفه یک وظیفه(مصوبه/گام) یک تسک ایجاد کند که در آن پروژه امکان ساختن برایش فعال باشد.\n' +
    '- همچنین سازنده یک وظیفه در کنار تایید کننده امکان حذف و ویرایش آن وظیفه را دارد. ( ثبت پیشرفت با توجه به تنظیمات قالب تنها برای تایید کننده امکان دارد.)\n' +
    '\tمدیریت پروژه\n' +
    '- مدیر پروژه می‌تواند فعالیت های زیر را علاوه بر فعالیت های بالا انجام دهد:\n' +
    '۱- ویرایش اعضا\n' +
    '۲- تغییر در تمام وظایف ساخته شده\n' +
    '۳- ثبت میزان پیشرفت برای تمام مجریان\n' +
    '\n' +
    'نکات قابل توجه:\n' +
    '* اعضای ضمنی به عنوان عضواصلی پروژه ( کمیته/برنامه) در نظر گرفته نمی شوند و در هنگام ایجاد پروژه به پروژه مورد نظر اضافه نمی‌گردند، بلکه، در هنگام ساخت یک وظیفه (مصوبه/گام) در صورت انتخاب یک فرد خارج از اعضای اصلی پروژه و محول نمودن وظیفه ای به ایشان، آن فرد به اعضای ضمنی پروژه اضافه می شود.\n' +
    ' * در صورتیکه در تنظیمات پروژه گزینه نمایش تمام وظایف فعال نباشد کاربرانی که گزنیه نمایش وظایف برای آنها فعال نیست تنها در صورتی آن وظیفه را می‌بینند که نقشی(مجری، تایید کننده، مطلع) در آن وظیفه داشته باشند.',
  addRole: 'افزودن سمت عضو',
  memberRoles: 'سمت‌های عضو',
  memberUsers: 'کاربران عضو',
  roleExistInProject: 'این سمت عضو پرژه است',
  differ: ' متفاوت است',
  migrateToRole: 'جایگزینی با سمت',
  pleaseSelectARole: 'لطفا یک سمت انتخاب کنید',
  showArvhied: 'نمایش پروژه های بایگانی شده',
  projectRole: 'نقش کاربر',
  chooseTemplates: 'قالب‌های مورد نظر برای پروژه را انتخاب کنید.',
  create: 'ساختن',
  createNewProject: 'ایجاد پروژه‌ی جدید',
  createProject: 'پروژه‌ی مورد نظر با موفقیت ایجاد شد.',
  enterCustomTitle: 'نقش کاربر را وارد کنید.',
  description: 'توضیحات',
  customTitle: 'نقش کاربر',
  explicit: 'کاربران اصلی',
  implicit: 'کاربران ضمنی',
  isImplicit: 'عضویت ضمنی',
  batchAddMembers: 'افزودن گروهی',
  memberRemoved: 'کاربر مورد نظر حذف شد.',
  members: 'اعضا',
  projectDeleted: 'پروژه‌ی مورد نظر حذف شد.',
  projectName: 'عنوان پروژه',
  save: 'ذخیره',
  tags: 'برچسب‌ها',
  tasks: 'وظیفه‌ها',
  templates: 'قالب‌ها',
  templatesList: 'فهرست قالب‌ها',
  updateProject: 'پروژه با موفقیت بروزرسانی شد.',
  visibleAllTasks: 'نمایش تمام وظیفه‌ها',
  youDoNotHaveAnyProject: 'شما هیچ پروژه‌ای ندارید.',

  moreThan1MemberMatchs(count: number) {
    return `${count} فرد با این سمت وجود دارند`;
  },

  changeImplicitMember(isImplicit: boolean) {
    const title = isImplicit ? 'کاربران اصلی' : 'کاربران ضمنی';
    return ` انتقال به ${title}`;
  },
  memberAddedToProject(memberName: string) {
    return i18n.t('memberAddedToProject', {
      ns: 'companyManagement',
      memberName,
    });
  },
  project(type: 'edit' | 'templates' | 'members', projectName?: string) {
    let msg = '';
    if (type === 'edit') {
      msg = 'ویرایش پروژه';
    } else if (type === 'templates') {
      msg = 'قالب‌های پروژه';
    } else if (type === 'members') {
      msg = 'اعضای پروژه';
    }
    if (projectName) {
      msg = `${msg}‌ی «${projectName}»`;
    }
    return msg;
  },
  projects(companyName: string) {
    const lang = getLanguageBaseOnTZ();
    let msg: string = '';
    if (lang === 'fa') {
      msg = companyName ? `پروژه‌های «${companyName}»` : 'پروژه‌ها';
    } else {
      msg = companyName ? `${companyName}'s projects` : 'projects';
    }
    return msg;
  },
  thereIsNoMemberYet(isImplicit: boolean) {
    return isImplicit
      ? i18n.t('implicitMemberError', { ns: 'companyManagement' })
      : i18n.t('primaryMemberError', { ns: 'companyManagement' });
  },
  thereIsNoRoleYet(isImplicit: boolean) {
    return isImplicit
      ? i18n.t('implicitRoleError', { ns: 'companyManagement' })
      : i18n.t('primaryRoleError', { ns: 'companyManagement' });
  },
  thisUserIsCurrentlyMemberOfTheProject(
    isImplicit: boolean,
    role: boolean = false
  ) {
    const roleOrUser = role
      ? i18n.t('role', { ns: 'companyManagement' })
      : i18n.t('user', { ns: 'companyManagement' });
    const title = isImplicit
      ? i18n.t('secondary', { ns: 'companyManagement' })
      : i18n.t('primary', { ns: 'companyManagement' });
    return i18n.t('addedToProject', {
      ns: 'companyManagement',
      roleOrUser,
      title,
    });
  },
  roleMemberCount(count: string) {
    return i18n.t('memberCount', {
      ns: 'companyManagement',
      count: convertDigitToProperFormat(count) as unknown as number,
    });
  },
  memberCount(count: number) {
    return i18n.t('memberCount', {
      ns: 'companyManagement',
      count: convertDigitToProperFormat(count) as unknown as number,
    });
  },
  defaultVerifier(customTitle: string | undefined) {
    return customTitle
      ? customTitle + ' ' + i18n.t('default', { ns: 'companyManagement' })
      : i18n.t('defaultTaskPublisher', { ns: 'companyManagement' });
  },
  defaultTaskPublisher(customTitle: string | undefined) {
    return customTitle
      ? customTitle + ' ' + i18n.t('default', { ns: 'companyManagement' })
      : i18n.t('defaultTaskPublisher', { ns: 'companyManagement' });
  },
  defaultSubTaskPublisher(customTitle: string | undefined) {
    return customTitle
      ? customTitle + ' ' + i18n.t('default', { ns: 'companyManagement' })
      : i18n.t('defaultTaskPublisher', { ns: 'companyManagement' });
  },
};

export default messages;
